import { createApp } from 'vue';
import { PerfectScrollbarPlugin } from 'vue3-perfect-scrollbar';
import PatientRegistration from './components/PatientRegistration/PatientRegistration.vue';

const app = createApp({});
app.component('patientregistration', PatientRegistration);

app.use(PerfectScrollbarPlugin);

app.mount('#app')
